

<template>
  <tq-dialog v-model="dialogState" top="32vh" title="提示" custom-class="tq-sensor-dialog" :before-close='confirmFn'>
    <div class="tip-content">
			<div class="title_cls">{{ fieldName }}填写的内容包含敏感词,</div>
			<div class="title_cls">请检查后重新提交</div>
			<div class="text_cls">如有疑问：请联系客服400-182-0660</div>
		</div>
		<template v-slot:footer>
			<div class="info-know" @click="confirmFn">
				<el-button link type='primary'>我知道了</el-button>
			</div>
		</template>
  </tq-dialog>
</template>

<script lang="ts" setup>
import tqDialog from '../../Dialog/index'
import { ref } from "vue";
defineOptions({
  name: "TqCensorDialog",
});
// 参数传递
const props = defineProps({
  handleClick: Function
});
const dialogState = ref(false);
const fieldName = ref('');
// 设置弹窗显示隐藏
const setVisible = (value: boolean) => {
  dialogState.value = value;
}
// 确认按钮
const confirmFn = () => {
  // dialogState.value = false; 
  if (props.handleClick && typeof props.handleClick === 'function') {
    props.handleClick(); // 调用父组件传递的方法
  }
}
// 使用 defineExpose 暴露方法
defineExpose({
  dialogState,
  props,
  fieldName,
  setVisible // 将 childMethod 方法暴露给父组件
});
</script>